export default "__VITE_ASSET__BvukNZnk__"